import { useContext, useRef, useState } from 'react';
import {
  alphabeticChar,
  createContainer,
  renderCrossOutOption,
  addPropsToNodes,
  getQuestionByReference,
} from 'chameleon/packages/blue-book-player/utils';
import useListenToRenderedQuestions from 'chameleon/packages/blue-book-player/hooks/useListenToRenderedQuestions';
import useGetPlayerEl from 'chameleon/packages/blue-book-player/hooks/useGetPlayerEl';
import { SELECTORS } from 'chameleon/packages/blue-book-player/constants/selectors';
import { BluebookContext } from '../state/BluebookContext';

const QuestionCrossOutInjector = ({
  crossOutReducer,
  learnosityApp,
  isStudentAccount,
}) => {
  const { state: playerState } = useContext(BluebookContext);
  const playerEl = useGetPlayerEl();
  const loadedQuestions = useRef([]);
  const [nodes, setNodes] = useState([]);
  const { isApcDataLoading, questions } = playerState;

  const doInject = (reference, questionApi) => {
    const question = getQuestionByReference(reference, questions);
    if (
      questionApi?.isMaskable() &&
      !loadedQuestions.current[question.itemId]
    ) {
      loadedQuestions.current[question.itemId] = true;
      const learnosityQuestion = questionApi?.getQuestion();
      createContainer(SELECTORS.OPTION_ANSWER, reference, playerEl).then(
        (optionElements) => {
          let letter = 'a';
          let newNodes = [];
          optionElements.forEach((optionElement) => {
            const node = renderCrossOutOption(optionElement.triggerContainer, {
              index: letter,
              optionContainer: optionElement.optionContainer,
              crossOutReducer,
              learnosityQuestionApi: questionApi,
              learnosityQuestion,
              isStudentAccount,
            });
            letter = alphabeticChar(letter).next();
            newNodes.push(node);
          });
          setNodes((currentNodes) => [...currentNodes, ...newNodes]);
        },
      );
    }
  };

  useListenToRenderedQuestions(playerState, learnosityApp, doInject);

  if (isApcDataLoading) {
    return null;
  }

  return addPropsToNodes(nodes, {
    crossOutReducer,
  });
};

export default QuestionCrossOutInjector;
